//React & Redux
import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";

// External Components
// Sanity Client
import { client } from "../../services/client";

//Internal Compoments
import Header from "../../components/layouts/Header/Header";
import BlogPostComponent from "../Blog/components/BlogPostComponent";
import TestFooter from "../../components/layouts/Footer/TestFooter";

//CSS
import "./mission.css";

export default function ViewLandingScreen(history) {
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const [pageContent, setPageContent] = useState();
  const [isContentReady, setIsContentReady] = useState(false);
  const [latestContent, setLatestContent] = useState();
  const [nextContent, setNextContent] = useState();

  let slug = "our-mission";

  async function getPosts() {
    const posts = await client.fetch("*[_type == 'post']");
    return posts;
  }

  useEffect(() => {
    const fetchData = async () => {
      let blogPosts = [];
      try {
        const response = await getPosts();

        if (response) {
          for (let i = 0; i < response.length; i++) {
            if (
              response[i].title.startsWith("LP_") ||
              response[i].title.startsWith("TUTORIAL_") ||
              response[i].title.startsWith("AOFL_") ||
              response[i].title.startsWith("PLAN_") ||
              response[i].title.startsWith("PRIME_") ||
              response[i].title.startsWith("PROCESS_") ||
              response[i].title.startsWith("PAGE_") ||
              response[i].title.startsWith("LOGO_")
            ) {
              console.log("not right");
            } else {
              blogPosts.push(response[i]);
            }
          }
        }
        setPageContent(blogPosts);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      {userInfo ? <Header variant="light" /> : <Header variant="light" />}

      <main className="landingpage__main">
        <div className="testimony--shift about">
          {pageContent &&
            pageContent
              .filter((page, i) => page.slug.current === slug)
              .map((p, i) => (
                <div key={i}>
                  <BlogPostComponent body={p.body} />
                </div>
              ))}
        </div>

        <TestFooter />
      </main>
    </>
  );
}
